import { useState } from 'react';
import {
  IconButton,
  Menu,
  MenuItem,
  makeStyles,
} from '@material-ui/core';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import AddIcon from '@material-ui/icons/Add';
import { checkPermission } from '../../../helpers/checkPermissions';
import permissions from '../../../config/permissions';
import {
  enqueueSnackbar,
  SNACKBAR_VARIANTS,
} from '../../../redux_store';

const useStyles = makeStyles((theme) => ({
  addNewButton: {
    border: `1px solid ${theme.colors.lightBlue}`,
    backgroundColor: 'white',
    marginLeft: 14,
    height: 38,
    width: 38,

    '&:hover': {
      backgroundColor: 'white',
      opacity: 0.8,
    },
  },
  t: {},
}));

const AddButton = ({
  toggleAssessmentModal,
  toggleResourceModal,
  setOrderPatientUuid,
  toggleProgramModal,
}) => {
  const classes = useStyles();
  const { en: { btn, notifications } } = useSelector((state) => state.i18n);
  const {
    patientUuid: paramsPatientUuid,
    accountUuid: paramAccountUuid,
  } = useParams();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const dispatch = useDispatch();
  const {
    metadata: {
      currentAccountPermissions,
      childAccountPermissions,
    },
  } = useSelector((state) => state.user);
  const hasOrderPermission = checkPermission(
    !paramAccountUuid
      ? currentAccountPermissions
      : childAccountPermissions,
    permissions.ORDER_CREATE,
  );
  const hasSurveyPermission = checkPermission(
    !paramAccountUuid
      ? currentAccountPermissions
      : childAccountPermissions,
    permissions.ORDER_SURVEY_CREATE,
  );
  const hasResourcesPermission = checkPermission(
    !paramAccountUuid
      ? currentAccountPermissions
      : childAccountPermissions,
    permissions.GET_RESOURCES,
  );
  const isProgramsAvailable = true //checkPermission(
  // currentAccountPermissions,
  // permissions.ADMIN_PATIENT_IMPORT,
  // );

  const handleAssessmentCreate = () => {
    handleClose();
    const hasPermission = checkPermission(
      !paramAccountUuid
        ? currentAccountPermissions
        : childAccountPermissions,
      permissions.ORDER_SURVEY_CREATE,
    );
    if (hasPermission) {
      toggleAssessmentModal(true);
    } else {
      dispatch(
        enqueueSnackbar({
          message: notifications.notPermissionForCreatingAssessment,
          options: {
            variant: SNACKBAR_VARIANTS.warning,
          },
        }),
      );
    }
  };

  const handleOrderCreate = () => {
    handleClose();
    if (hasOrderPermission) {
      setOrderPatientUuid(paramsPatientUuid);
    } else {
      dispatch(
        enqueueSnackbar({
          message: notifications.notPermissionForCreatingOrder,
          options: {
            variant: SNACKBAR_VARIANTS.warning,
          },
        }),
      );
    }
  };

  const handleProgramCreate = () => {
    handleClose();
    if (isProgramsAvailable) {
      toggleProgramModal(true);
    } else {
      dispatch(
        enqueueSnackbar({
          message: notifications.notPermissionForCreatingProgram,
          options: {
            variant: SNACKBAR_VARIANTS.warning,
          },
        }),
      );
    }
  };

  const handleResourceCreate = () => {
    handleClose();
    toggleResourceModal(true);
  };

  return <>
    <IconButton className={classes.addNewButton}
      onClick={handleClick}
    >
      <AddIcon color='primary' />
    </IconButton>

    <Menu anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      getContentAnchorEl={null}
    >
      <MenuItem disabled={!hasSurveyPermission}
        onClick={handleAssessmentCreate}>{btn.createAssessment}</MenuItem>
      <MenuItem disabled={!hasResourcesPermission}
        onClick={handleResourceCreate}>{btn.createResource}</MenuItem>
      <MenuItem disabled={!hasOrderPermission}
        onClick={handleOrderCreate}>{btn.createOrder}</MenuItem>
      {/*<MenuItem disabled={!hasOrderPermission}*/}
      {/*          onClick={handleProgramCreate}>{btn.createProgram}</MenuItem>*/}
    </Menu>
  </>;
};

export default AddButton;
